import { toast } from "./message-helper";

export const downloadFile = (url) => {
    try {
        window.open(url, "_blank").focus();
    } catch (error) {
        toast.info(
            "El archivo se ha descargado pero probablemente tengas las ventanas emergentes del navegador desactivadas, actívalas y vuelve a intentarlo"
        );
    }
};
